import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import { InputNumber } from 'primereact/inputnumber';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Checkbox } from 'primereact/checkbox';
import { Toast } from 'primereact/toast';

import { Button } from 'primereact/button';
import { useConfigFrecuencia } from './useConfigFrecuencia';
import TableConfig from './TableConfig';
import DatosConfig from './DatosConfig';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useState } from 'react';

const ConfigFrecuencia = () => {
    const {
        toast,
        cargaProyecto,
        proyecto,
        setProyecto,
        lstProyecto,
        cargaPuesto,
        lstPuesto,
        cargaHorario,
        horario,
        lstHorario,
        horarioItemTemplate,
        horarioSelectTemplate,
        setHorario,
        cargaDetHorario,
        detHorario,
        lstDetHorario,
        turnoItemTemplate,
        turnoSelectTemplate,
        setDetHorario,
        cantidad,
        setCantidad,
        ctrlDisabled,
        esAleatorio,
        handleClick,
        procesando,
        intervalo,
        setIntervalo,
        handleCheckAleatorio,
        disabledRandom,
        limInf,
        limSup,
        setLimInf,
        setLimSup,
        controlDisabledIntervalo,
        multiPuesto,
        setMultiPuesto,
        cargaEstadoConf,
        estadoConf,
        setEstadoConf,
        lstEstadoConf,
        tolerancia,
        setTolerancia, 
        diasSemana,
        diasSelect, setDiasSelect, renderKey
    } = useConfigFrecuencia();

    

    return (
        <div className="card">
            <Toast ref={toast} />
            <h5>Configuracion de frecuencia de Reporte</h5>
            <div className="formgrid grid p-fluid mb-3">
                {/* Proyecto */}
                <div className="field col-12 md:col-6">
                    <label htmlFor="cboProyecto">Proyecto:</label>
                    {cargaProyecto ? (
                        <div className="flex align-items-center">
                            <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />
                        </div>
                    ) : (
                        <Dropdown inputId="cboProyecto" value={proyecto} onChange={(evt) => setProyecto(evt.value)} options={lstProyecto} optionLabel="descripcion" placeholder="Elija un Proyecto" filter showClear />
                    )}
                </div>
                {/* Puesto */}
                <div className="field col-12 md:col-6">
                    <label htmlFor="cboPuesto">Puesto:</label>
                    {cargaPuesto ? (
                        <div className="flex align-items-center">
                            <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />
                        </div>
                    ) : (
                        <MultiSelect value={multiPuesto} onChange={(evt) => setMultiPuesto(evt.value)} options={lstPuesto} optionLabel="descripcion" filter maxSelectedLabels={3} />
                    )}
                </div>

                {/* bloque Columna 1*/}
                <div className="field col-12 md:col-8">
                    <div className="formgrid grid p-fluid mb-3">
                        {/* Horario */}
                        <div className="field col-12 md:col-6">
                            <label htmlFor="cboHorario">Horario:</label>
                            {cargaHorario ? (
                                <div className="flex align-items-center">
                                    <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />
                                </div>
                            ) : (
                                <Dropdown
                                    inputId="cboHorario"
                                    value={horario}
                                    onChange={(evt) => setHorario(evt.value)}
                                    options={lstHorario}
                                    optionLabel="sigla"
                                    itemTemplate={horarioItemTemplate}
                                    valueTemplate={horarioSelectTemplate}
                                    placeholder="Elija un Horario"
                                    filter
                                    showClear
                                />
                            )}
                        </div>
                        {/* Detalle Horario */}
                        <div className="field col-12 md:col-6">
                            <label htmlFor="cboDetHorario">Detalle Horario:</label>
                            {cargaDetHorario ? (
                                <div className="flex align-items-center">
                                    <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />
                                </div>
                            ) : (
                                <Dropdown
                                    inputId="cboDetHorario"
                                    value={detHorario}
                                    onChange={(evt) => setDetHorario(evt.value)}
                                    options={lstDetHorario}
                                    optionLabel="horarioDetalleId"
                                    placeholder="Elija detalle de Horario"
                                    itemTemplate={turnoItemTemplate}
                                    valueTemplate={turnoSelectTemplate}
                                    filter
                                    showClear
                                />
                            )}
                        </div>
                        {/* Estado */}
                        <div className="field col-12 md:col-6">
                            <label htmlFor="cboEstado">Estado:</label>
                            {cargaEstadoConf ? (
                                <div className="flex align-items-center">
                                    <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />
                                </div>
                            ) : (
                                <Dropdown inputId="cboEstado" value={estadoConf} onChange={(evt) => setEstadoConf(evt.value)} options={lstEstadoConf} optionLabel="nombre" placeholder="Elija Estado" filter />
                            )}
                        </div>
                        {/* Tolerancia de Monitor */}
                        <div className="field col-12 md:col-6">
                            <label htmlFor="txtTolerancia">Tolerancia Monitor:</label>
                            <InputNumber inputId="txtTolerancia" showButtons step={1} min={30} max={50} value={tolerancia} onValueChange={(evt) => setTolerancia(evt.value)} mode="decimal" disabled={ctrlDisabled} />
                        </div>
                        <div className="field col-12 md:col-12">
                            <span> <hr /> { '  ' }</span>
                        </div>
                        {/* Frecuencia */}
                        <div className="field col-12 md:col-6">
                            <label htmlFor="txtFrecuencia">Frecuencia:</label>
                            <InputNumber inputId="txtFrecuencia" showButtons step={1} min={1} max={10} value={cantidad} onValueChange={(evt) => setCantidad(evt.value)} mode="decimal" disabled={ctrlDisabled} />
                        </div>
                        {/* Intervalos */}
                        <div className="field col-12 md:col-6">
                            <label htmlFor="txtIntervalos">Intervalos (en horas)</label>
                            <InputNumber inputId="txtIntervalos" showButtons step={1} min={1} max={5} disabled={controlDisabledIntervalo()} mode="decimal" value={intervalo} onValueChange={(e) => setIntervalo(e.value)} />
                        </div>
                    </div>
                </div>

                {/* bloque Columna 2*/}
                <div className="field col-12 md:col-4">
                    <DataTable value={diasSemana} size="small" stripedRows selection={diasSelect} selectionMode="checkbox" onSelectionChange={(e) => setDiasSelect(e.value)} dataKey="id">
                        <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
                        <Column header="Dias Activo" field="nombre"></Column>
                    </DataTable>
                </div>
                {/* Es Aleatorio */}
                <div className="field col-12 md:col-8 ">
                    <div className="flex justify-around">
                        <Checkbox inputId="chkAleatorio" onChange={handleCheckAleatorio} checked={esAleatorio} disabled={ctrlDisabled} /> <label htmlFor="chkAleatorio">Intervalos Aleatorios</label>
                        <div className="flex flex-col">
                            <label className="block">Limite Inferior</label>
                            <InputNumber showButtons step={1} min={1} max={5} mode="decimal" value={limInf} onValueChange={(e) => setLimInf(e.value)} disabled={disabledRandom} />
                        </div>
                        <div className="flex flex-col">
                            <label>Limite Superior</label>
                            <InputNumber showButtons step={1} min={1} max={5} mode="decimal" value={limSup} onValueChange={(e) => setLimSup(e.value)} disabled={disabledRandom} />
                        </div>
                    </div>
                </div>
                <div className="field col-12 md:col-4 ">
                    <Button label="Registrar Configuración" onClick={handleClick} loading={procesando} disabled={ctrlDisabled} />
                </div>
            </div>
            <div className="formgrid grid p-fluid mb-3">
                <div className="field col-12 md:col-12 ">
                    {/** <TableConfig /> */}
                    <DatosConfig key={renderKey} />
                </div>
            </div>
        </div>
    );
};

export default ConfigFrecuencia;
